<mat-paginator
  class="no-shadow"
  [hidden]="paginator.loading"
  (page)="handlePageEvent($event)"
  [length]="paginator.length"
  [pageSize]="paginator.pageSize"
  [pageIndex]="paginator.pageIndex"
  [pageSizeOptions]="paginator.pageSizeOptions"
  [showFirstLastButtons]="true"
  aria-label="Select page" />
